import React from "react"
import { SectionTitle, DataTable, PaginationControls } from "../components"
import { cardStyle, loadingStyle } from "../styles/commonStyles"
import { formatThaiBuddhistDate } from "../../../libs/dateUtils"
import { getPaginationInfo } from "../utils/helpers"

const OtpLogsTab = ({ data: otpLogs, loading, currentPage, totalPages, totalCount, perPage, fetchData, id }) => {
	const { indexOfFirstItem } = getPaginationInfo(currentPage, perPage, totalCount)

	const handlePageChange = (page) => {
		fetchData(id, page)
	}

	const headers = ["#", "วันที่สร้าง", "หมายเลขโทรศัพท์", "OTP", "รหัสอ้างอิง", "ประเภท", "ยืนยันแล้ว", "วันที่ยืนยัน"]

	const rows = (otpLogs || []).map((otp, index) => [
		`${indexOfFirstItem + index}.`,
		formatThaiBuddhistDate(otp.createdAt),
		otp.msisdn,
		otp.otp,
		otp.ref,
		otp.type,
		<span key="verified" style={{ color: otp.isVerified ? "green" : "red" }}>
			{otp.isVerified ? "Yes" : "No"}
		</span>,
		formatThaiBuddhistDate(otp.verifiedAt),
	])

	return (
		<div className="card-style" style={cardStyle}>
			<SectionTitle title="ประวัติการส่ง OTP" />

			{loading && (
				<div
					style={{
						...loadingStyle,
						position: "absolute",
						top: "50%",
						left: "50%",
						transform: "translate(-50%, -50%)",
						background: "rgba(255,255,255,0.8)",
						zIndex: 10,
					}}
				>
					กำลังโหลด...
				</div>
			)}

			<div style={{ position: "relative", opacity: loading ? 0.6 : 1 }}>
				<DataTable headers={headers} rows={rows} emptyMessage="ไม่พบข้อมูลการส่ง OTP" />

				{totalPages > 1 && (
					<PaginationControls
						currentPage={currentPage}
						totalPages={totalPages}
						totalCount={totalCount}
						perPage={perPage}
						isLoading={loading}
						onPageChange={handlePageChange}
					/>
				)}
			</div>
		</div>
	)
}

export default OtpLogsTab
